import { __awaiter } from "tslib";
import { ScheduleDetailService } from "@/services/models/schedule/scheduleDetail";
import moment from "moment";
const moduleScheduleDetail = {
    namespaced: true,
    state: {
        scheduleDetails: [],
        selectedScheduleDetails: [],
        originalScheduleDetails: [],
        loading: false,
        consultationTypeIdSelected: null,
    },
    getters: {
        getScheduleDetails(state) {
            let orderedScheduleDetails = state.scheduleDetails.sort((a, b) => {
                const timeStart = moment(a.time_start, "hh:mm");
                const timeEnd = moment(b.time_start, "hh:mm");
                const diffTime = timeStart.diff(timeEnd);
                //Si la diferencia es 0 significa que tienen la misma hora y una debe ser sobrecupo
                if (diffTime == 0) {
                    //Al ser iguales se ordenan según id, quedando última el último cupo agregado, el cual siempre será el sobrecupo
                    if (a.id > b.id) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }
                else {
                    return diffTime;
                }
            });
            // orderedScheduleDetails = state.scheduleDetails.map((scheduleDetail) => {
            //     return {
            //       ...scheduleDetail,
            //       consultation_type_selected: scheduleDetail.consultation_type
            //     };
            //   });
            // if (state.consultationTypeIdSelected) {
            //   console.log("entered");
            //   orderedScheduleDetails = state.scheduleDetails.map((scheduleDetail) => {
            //     return {
            //       ...scheduleDetail,
            //       // consultation_type_id: state.consultationTypeIdSelected,
            //     };
            //   });
            // }
            return orderedScheduleDetails;
        },
        getLoading(state) {
            return state.loading;
        },
        getSelectedScheduleDetails(state) {
            return state.selectedScheduleDetails;
        },
    },
    mutations: {
        setConsultationTypeIdSelected(state, consultationTypeIdSelected) {
            state.consultationTypeIdSelected = consultationTypeIdSelected;
        },
        setScheduleDetails(state, scheduleDetails) {
            state.scheduleDetails = scheduleDetails;
        },
        setOriginalScheduleDetails(state, scheduleDetails) {
            state.originalScheduleDetails = scheduleDetails;
        },
        setSelectedScheduleDetails(state, scheduleDetails) {
            state.selectedScheduleDetails = scheduleDetails || [];
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        filterFreeHours(state) {
            state.scheduleDetails = state.originalScheduleDetails.filter((scheduleDetail) => scheduleDetail.state == "disponible");
        },
        filterIsOvercrowding(state) {
            state.scheduleDetails = state.originalScheduleDetails.filter((scheduleDetail) => scheduleDetail.is_overcrowding == "si");
        },
        filterBlockedHours(state) {
            state.scheduleDetails = state.originalScheduleDetails.filter((scheduleDetail) => scheduleDetail.state == "bloqueada");
        },
        cleanScheduleDetails(state) {
            state.scheduleDetails = state.originalScheduleDetails;
        },
    },
    actions: {
        getByDaySelectedId({ commit }, daySelectedId) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                let scheduleDetails = yield ScheduleDetailService.getByDaySelectedId(daySelectedId);
                scheduleDetails = scheduleDetails.map((scheduleDetail) => {
                    return Object.assign(Object.assign({}, scheduleDetail), { consultation_type_selected: scheduleDetail.consultation_type });
                });
                commit("setScheduleDetails", scheduleDetails);
                commit("setOriginalScheduleDetails", scheduleDetails);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleScheduleDetail;
